<template>
  <div class="online-header bg-base">
    <div class="header-all" v-if="$route.meta.isStudyTitle">
      <div class="header-left">
        <router-link class="logo" tag="div" :to="{ path: '/' }">
          <img src="../assets/images/header/logo.png" alt />
        </router-link>
      </div>
      <div class="header-right study-header">
        <div class="two-left">
          <div class="header-task">
            <router-link
              :to="{ path: '/Review' }"
              class="tabs"
              :class="currentHeaderState.state == 1 ? 'cur' : ''"
              >{{ $store.state.globalTxt.studymenu1
                    ? $store.state.globalTxt.studymenu1
                    :$t("Header.review") }}</router-link
            >
            <router-link
              :to="{ path: '/studyEvaluate/evaluationList' }"
              class="tabs"
              :class="currentHeaderState.state == 2 ? 'cur' : ''"
              >{{ $store.state.globalTxt.studymenu2
                    ? $store.state.globalTxt.studymenu2
                    :$t("Header.evaluation") }}</router-link
            >
            <!--<router-link v-if="stuGen=='kid' && languageType=='zh'" :to="{path:'/Mp3'}" class="tabs">mp3</router-link>-->
            <router-link
              v-if="kctvIsOpen == 1"
              :to="{ path: '/Classroom' }"
              class="tabs"
              >{{ $store.state.globalTxt.studymenu5
                    ? $store.state.globalTxt.studymenu5
                    :$t("Header.FunClass") }}</router-link
            >
            <router-link :to="{ path: '/Video' }" class="tabs">{{
              $store.state.globalTxt.studymenu3
                    ? $store.state.globalTxt.studymenu3
                    :$t("Header.vedio")
            }}</router-link>
            <router-link
              :to="{ path: '/Book' }"
              class="tabs"
              :class="currentHeaderState.state == 5 ? 'cur' : ''"
              >{{ $store.state.globalTxt.studymenu4
                    ? $store.state.globalTxt.studymenu4
                    :$t("Header.book") }}</router-link
            >
          </div>
        </div>
        <div class="two-right">
          <div class="monery-box">
            <span>
              <em class="gold monery"></em>
              {{ $store.state.currentChild.student_goldprice || 0 }}
            </span>
            <span>
              <em class="diamond monery"></em>
              {{ $store.state.currentChild.student_diamondprice || 0 }}
            </span>
          </div>
          <div class="quit">
            <div class="Avatar">
              <router-link :to="{ path: '/MyCenter/mine' }" tag="a">
                <img
                  v-if="stuList.student_img != ''"
                  :src="stuList.student_img"
                  alt
                />
                <img
                  v-else-if="
                    stuList.student_img == '' &&
                      stuList.student_sex == $t('Common.woman')
                  "
                  src="@/assets/images/childWoman.png"
                  alt
                />
                <img
                  v-else-if="
                    stuList.student_img == '' &&
                      stuList.student_sex == $t('Common.man')
                  "
                  src="@/assets/images/childMan.png"
                  alt
                />
                <img
                  v-else-if="
                    stuList.student_img == '' && stuList.student_sex == ''
                  "
                  src="@/assets/images/childImg.png"
                  alt
                />
                <!-- <img v-if="stuList.student_img !=''" :src="stuList.student_img" alt />
                <img v-else src="@/assets/images/childImg.png" alt />-->
              </router-link>
              <span @click="quitLogin" class="cursor">{{
                $t("Common.quit")
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="$route.meta.isEvalutionTitle" class="evalution-title">
      <div class="evalution-title-left">
        {{ InfoNameQuestion }} ({{ InfocurrentQuestion }}/{{
          InfoAllQuestion
        }}）
      </div>
      <div class="evalution-title-center">
        <em></em>
        <span
          >{{ Math.floor(remainTimes / 60) }}'{{
            Math.floor(remainTimes % 60)
          }}"</span
        >
      </div>
      <div class="evalution-title-right">
        <span
          class="baby cursor"
          style="margin-right:20px;"
          @click="isEquitTest"
          >{{ $t("Common.quitEvalute") }}</span
        >
        <div class="Avatar">
          <img
            v-if="stuList.student_img != ''"
            :src="stuList.student_img"
            alt
          />
          <img
            v-else-if="
              stuList.student_img == '' &&
                stuList.student_sex == $t('Common.woman')
            "
            src="@/assets/images/childWoman.png"
            alt
          />
          <img
            v-else-if="
              stuList.student_img == '' &&
                stuList.student_sex == $t('Common.man')
            "
            src="@/assets/images/childMan.png"
            alt
          />
          <img
            v-else-if="stuList.student_img == '' && stuList.student_sex == ''"
            src="@/assets/images/childImg.png"
            alt
          />
        </div>
        <span class="baby">{{ stuList.student_cnname }}</span>
      </div>
    </div>
    <div v-else-if="$route.meta.isWrongAnalyTitle" class="evalution-title">
      <div class="evalution-title-left">
        {{ InfoNameQuestion1 }} ({{ InfocurrentQuestion1 }}/{{
          InfoAllQuestion1
        }}）
      </div>
      <!-- <div class="evalution-title-center">
        <em></em>
        <span>00:00:00</span>
      </div>-->
      <div class="evalution-title-right">
        <div class="Avatar">
          <img
            v-if="stuList.student_img != ''"
            :src="stuList.student_img"
            alt
          />
          <img
            v-else-if="
              stuList.student_img == '' &&
                stuList.student_sex == $t('Common.woman')
            "
            src="@/assets/images/childWoman.png"
            alt
          />
          <img
            v-else-if="
              stuList.student_img == '' &&
                stuList.student_sex == $t('Common.man')
            "
            src="@/assets/images/childMan.png"
            alt
          />
          <img
            v-else-if="stuList.student_img == '' && stuList.student_sex == ''"
            src="@/assets/images/childImg.png"
            alt
          />
        </div>
        <span class="baby">{{ stuList.student_cnname }}</span>
      </div>
    </div>
    <div class="header-all" v-else>
      <div class="header-left">
        <router-link class="logo" tag="div" :to="{ path: '/' }">
          <img src="../assets/images/header/logo.png" alt />
        </router-link>
      </div>
      <div class="header-right">
        <div class="two-left">
          <div class="header-task">
            <template v-if="stuGen == 'school'">
              <router-link
                v-if="$store.state.has_num"
                :to="{ path: '/TaskCenter' }"
                tag="a"
                class="tabs"
              >
                {{
                  $store.state.globalTxt.homemenu1
                    ? $store.state.globalTxt.homemenu1
                    : $t("Header.task")
                }}
              </router-link>
              <a
                href="javascript:;"
                v-else
                @click="linkToTaskCenter"
                class="tabs"
              >
                {{
                  $store.state.globalTxt.homemenu1
                    ? $store.state.globalTxt.homemenu1
                    : $t("Header.task")
                }}
              </a>
            </template>
            <template v-else-if="stuGen == 'kid'">
              <router-link
                v-if="$store.state.has_num"
                :to="{ path: '/TaskCenter' }"
                tag="a"
                class="tabs"
              >
                {{
                  $store.state.globalTxt.homemenu1
                    ? $store.state.globalTxt.homemenu1
                    : $t("Header.myTask")
                }}
              </router-link>
              <a
                href="javascript:;"
                v-else
                @click="linkToTaskCenter"
                class="tabs"
              >
                {{
                  $store.state.globalTxt.homemenu1
                    ? $store.state.globalTxt.homemenu1
                    : $t("Header.myTask")
                }}
              </a>
            </template>
            <router-link :to="{ path: '/StudyCenter' }" tag="a" class="tabs">
              {{
                $store.state.globalTxt.homemenu2
                  ? $store.state.globalTxt.homemenu2
                  : $t("Header.studyCenter")
              }}
            </router-link>
            <router-link :to="{ path: '/MyCenter' }" tag="a" class="tabs">
              {{ $t("Header.myCenter") }}
            </router-link>
          </div>
        </div>
        <div class="two-right">
          <div class="monery-box">
            <span>
              <em class="gold monery"></em>
              {{ $store.state.currentChild.student_goldprice || 200 }}
            </span>
            <span>
              <em class="diamond monery"></em>
              {{ $store.state.currentChild.student_diamondprice || 100 }}
            </span>
          </div>
          <div class="quit">
            <div class="Avatar">
              <router-link tag="a" :to="{ path: '/MyCenter/mine' }">
                <img
                  v-if="stuList.student_img != ''"
                  :src="stuList.student_img"
                  alt
                />
                <img
                  v-else-if="
                    stuList.student_img == '' &&
                      stuList.student_sex == $t('Common.woman')
                  "
                  src="@/assets/images/childWoman.png"
                  alt
                />
                <img
                  v-else-if="
                    stuList.student_img == '' &&
                      stuList.student_sex == $t('Common.man')
                  "
                  src="@/assets/images/childMan.png"
                  alt
                />
                <img
                  v-else-if="
                    stuList.student_img == '' && stuList.student_sex == ''
                  "
                  src="@/assets/images/childImg.png"
                  alt
                />
              </router-link>
              <span @click="quitLogin" class="cursor">{{
                $t("Common.quit")
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 退出 弹窗 -->
    <popTips
      :dialogVisable="quitItem"
      :popTipsCont="popTips_quit"
      @handConfirm="handConfirm"
      @handCancel="quitItem = false"
      @handleCloseTip="quitItem = false"
    ></popTips>

    <!-- 退出作答题目 弹窗 -->
    <popTips
      :dialogVisable="closeItem"
      :popTipsCont="popTips_close"
      @handConfirm="handConfirmEquit"
      @handCancel="handCancelEquit"
      @handleCloseTip="handleCloseTipEquit"
    ></popTips>

    <pop-tips
      @handConfirm="handLinkTask"
      @handleCloseTip="handleCloseTip"
      :dialogVisable="popTipsCont.dialogVisable"
      :popTipsCont="popTipsCont"
    ></pop-tips>
  </div>
</template>
<script>
import popTips from "../components/popTips";
import Api from "@/views/Home/indexApi";
export default {
  name: "Header",
  components: {
    popTips,
  },
  data() {
    return {
      languageType: "zh", // 是大陆还是台湾
      undonenums: 0,
      flagStudentType: "",
      quitItem: false, //删除孩子
      popTipsCont: {
        dialogVisable: false,
        title: this.$t("Common.tips"),
        context: this.$t("Header.noData"),
        btns: [
          {
            text: this.$t("Common.confirm"),
            event: "handConfirm",
          },
        ],
      },
      // 退出登录 - 提示弹窗
      popTips_quit: {
        // btn_text1: "确定删除",
        // btn_text2: "我在想想",
        title: this.$t("Common.tips"),
        context: this.$t("Header.quitAccount"),
        btns: [
          {
            text: this.$t("Common.confirm"),
            event: "handConfirm",
          },
          {
            text: this.$t("Common.think"),
            event: "handCancel",
          },
        ],
      },
      studentInfo: {},
      currentHeaderState: {
        state: "",
      },
      // 是否退出测评 - 提示弹窗
      closeItem: false, //是否退出测评
      popTips_close: {
        // btn_text1: "确定删除",
        // btn_text2: "我在想想",
        title: this.$t("Common.tips"),
        context: this.$t("Common.invalid"),
        btns: [
          {
            text: this.$t("Common.quit"),
            event: "handConfirm",
          },
          {
            text: this.$t("Common.think"),
            event: "handCancel",
          },
        ],
      },
    };
  },
  mounted() {},
  updated() {},
  created() {
    this.studentInfo = this.$store.state.currentChild;
    if (this.$store.state.currentChild.class_genre == "school") {
      //少儿-校
      this.flagStudentType = "school";
    } else if (this.$store.state.currentChild.class_genre == "kid") {
      //幼儿 - 园
      this.flagStudentType = "kid";
    }
    this.languageType = this.$Tool.getStorage("languageType"); //学前(幼儿)不显示mp3
    if (this.$store.state.token) {
      this.getNodonums();
    }
  },
  watch: {
    $route(to, from, next) {
      if (to.path == "/ReviewMaps") {
        //复习
        this.currentHeaderState.state = 1;
      } else if (to.path == "/studyEvaluate/evaluateChild") {
        //测评
        this.currentHeaderState.state = 2;
      } else if (to.path == "/BookOutlink") {
        //图书
        this.currentHeaderState.state = 5;
      } else {
        this.currentHeaderState.state = "";
      }
    },
  },
  computed: {
    //剩余时间
    remainTimes() {
      return this.$store.state.remainTime;
    },
    //考题名称
    InfoNameQuestion() {
      return this.$store.state.InfoNameQuestion;
    },
    //当前第几题
    InfocurrentQuestion() {
      return this.$store.state.InfocurrentQuestion;
    },
    //总共多少题
    InfoAllQuestion() {
      return this.$store.state.InfoAllQuestion;
    },
    //考题分析 - 考题名称
    InfoNameQuestion1() {
      return this.$store.state.InfoNameQuestion1;
    },
    //考题分析 - 当前第几题
    InfocurrentQuestion1() {
      return this.$store.state.InfocurrentQuestion1;
    },
    //考题分析 - 总共多少题
    InfoAllQuestion1() {
      return this.$store.state.InfoAllQuestion1;
    },
    //当前孩子信息 是校还是园
    stuGen() {
      return this.$store.state.currentChild.class_genre;
    },
    stuList() {
      return this.$store.state.currentChild;
    },
    kctvIsOpen() {
      return this.$store.state.currentChild.classcode_kctvopen;
    },
  },
  methods: {
    linkToTaskCenter() {
      if (this.$store.state.has_num) {
        this.$router.push({
          path: "/TaskCenter",
        });
      } else {
        this.popTipsCont.dialogVisable = true;
      }
    },
    handleCloseTip() {
      this.popTipsCont.dialogVisable = false;
    },
    handLinkTask() {
      this.popTipsCont.dialogVisable = false;
    },
    getNodonums() {
      Api.getNodonums({
        student_id: this.$store.state.currentChild.student_id,
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
      }).then((res) => {
        const { list } = res.data.result;
        this.has_num = list.has_num;
        this.undonenums = list.undonenums;
        this.$Tool.setStorage("undonenums", this.undonenums);
        this.$store.dispatch("setundonenums", this.undonenums);
        this.$Tool.setStorage("has_num", this.has_num);
        this.$store.dispatch("sethas_num", this.has_num);
      });
    },
    //退出登录
    quitLogin() {
      this.quitItem = !this.quitItem;
    },
    //退出登录 - 确定
    handConfirm() {
      // this.message = "退出登录";
      // this.showTip = true;
      this.$Tool.removeStorage("token");
      this.$Tool.removeStorage("member_id");
      // this.$Tool.removeStorage("isPlay");
      this.$store.dispatch("setUserToken", "");
      this.$store.dispatch("setMemberId", "");

      this.$Tool.setStorage("isPlay", false);
      this.$store.dispatch("setbgMusic", false);
      if (!this.$Tool.getStorage("rember")) {
        this.$Tool.setStorage("psw", ""); //密码
        this.$Tool.setStorage("account", ""); //账号
      }
      // this.$router.push({ path: "/login" });
      window.location.href = "/login";
    },
    //是否退出测评
    isEquitTest() {
      this.closeItem = true;
    },
    //退出测评 - 确定
    handConfirmEquit() {
      this.closeItem = false;
      let allTime = this.$Tool.getStorage("allTime");
      this.$Tool.setStorage("remainTime", 0); //考试时间
      this.$store.dispatch("setRemainTime", 0);
      if (this.$route.query.from == "task") {
        this.$router.push({
          path: "/TaskCenter",
        });
      } else {
        this.$router.push({
          path: "/studyEvaluate/evaluateChild",
          query: {
            textbook_id: this.$store.state.textBookId,
            textbook_cnname: escape(this.$store.state.textbookCnname),
          },
        });
      }
    },
    //退出测评 - 取消
    handCancelEquit() {
      this.closeItem = false;
      // history.pushState(null, null, document.URL);
    },
    //退出测评 - 关闭
    handleCloseTipEquit() {
      this.closeItem = false;
      // history.pushState(null, null, document.URL);
    },
  },
};
</script>

<style lang="less">
img {
  cursor: pointer;
}
.logo {
  img {
    cursor: pointer;
  }
  .online-header {
    .header-task {
      .tabs {
        cursor: pointer;
      }
    }
  }
}
</style>
